import React from 'react';
import { useTranslation } from 'react-i18next';

const PdfLayoutLegacyWarning = ({ className = 'mt-2 mb-0' }) => {
    const { t } = useTranslation();

    return (
        <div
            className={`alert alert-warning alert-inline py-2 px-3 small ${className}`}
            role="alert"
        >
            <span className="alert-inline-body">
                {t('settings.default_layouts.legacy_layout_warning')}
            </span>
        </div>
    );
};

export default PdfLayoutLegacyWarning;
